import React, { useState, useEffect } from 'react';
import tiktokAPI from '../services/tiktokAPI';

export default function GiftsDetails({ username, isVisible }) {
  const [gifts, setGifts] = useState({
    gifts: [],
    totalGifts: 0,
    totalDiamonds: 0,
    lastUpdated: null
  });
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const [dataSource, setDataSource] = useState('real');

  // جلب تفاصيل الهدايا
  const fetchGiftsDetails = async () => {
    if (!username || !isVisible) return;

    setIsLoading(true);
    setError('');

    try {
      const result = await tiktokAPI.getGiftsDetails(username);
      
      if (result.success) {
        setGifts(result.data);
        setDataSource('real');
        console.log('تم جلب تفاصيل الهدايا بنجاح:', result.data);
      } else {
        throw new Error(result.error || 'فشل في جلب تفاصيل الهدايا');
      }

    } catch (error) {
      console.error('خطأ في جلب تفاصيل الهدايا:', error);
      setError(`خطأ في جلب الهدايا: ${error.message}`);
      setDataSource('mock');
      
      // استخدام البيانات المحاكاة
      const mockResult = await tiktokAPI.getMockGifts();
      if (mockResult.success) {
        setGifts(mockResult.data);
      }
    } finally {
      setIsLoading(false);
    }
  };

  // تحديث الهدايا كل دقيقة
  useEffect(() => {
    if (!username || !isVisible) return;

    fetchGiftsDetails();

    const interval = setInterval(() => {
      fetchGiftsDetails();
    }, 60000); // كل دقيقة

    return () => clearInterval(interval);
  }, [username, isVisible]);

  const formatTime = (timestamp) => {
    const now = Date.now();
    const diff = now - timestamp;
    
    if (diff < 60000) return 'الآن';
    if (diff < 3600000) return `${Math.floor(diff / 60000)} دقيقة`;
    if (diff < 86400000) return `${Math.floor(diff / 3600000)} ساعة`;
    return `${Math.floor(diff / 86400000)} يوم`;
  };

  const formatNumber = (num) => {
    if (num >= 1000000) {
      return (num / 1000000).toFixed(1) + 'M';
    }
    if (num >= 1000) {
      return (num / 1000).toFixed(1) + 'K';
    }
    return num.toString();
  };

  const getDataSourceColor = () => {
    return dataSource === 'real' ? '#28a745' : '#ffc107';
  };

  const getDataSourceText = () => {
    return dataSource === 'real' ? 'بيانات حقيقية' : 'بيانات محاكاة';
  };

  if (!isVisible) return null;

  return (
    <div style={{
      background: 'var(--bg-card)',
      borderRadius: '15px',
      padding: '20px',
      boxShadow: '0 4px 20px var(--shadow-color)',
      marginBottom: '20px',
      fontFamily: 'Cairo',
      border: '1px solid var(--border-color)'
    }}>
      <h3 style={{
        margin: '0 0 20px 0',
        color: 'var(--text-primary)',
        fontSize: 'clamp(14px, 3vw, 18px)',
        fontWeight: 'bold',
        textAlign: 'center',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '10px'
      }}>
        <span>🎁</span>
        تفاصيل الهدايا
        <span>🎁</span>
      </h3>

      {/* حالة الاتصال ومصدر البيانات */}
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        fontSize: '12px',
        marginBottom: '15px'
      }}>
        <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: '5px'
        }}>
          <div style={{
            width: '8px',
            height: '8px',
            borderRadius: '50%',
            backgroundColor: isLoading ? '#ffc107' : '#28a745'
          }}></div>
          <span style={{ color: 'var(--text-secondary)' }}>
            {isLoading ? 'جاري التحميل...' : 'متصل'}
          </span>
        </div>
        
        <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: '5px'
        }}>
          <div style={{
            width: '8px',
            height: '8px',
            borderRadius: '50%',
            backgroundColor: getDataSourceColor()
          }}></div>
          <span style={{ color: 'var(--text-secondary)' }}>
            {getDataSourceText()}
          </span>
        </div>
      </div>

      {/* رسالة الخطأ */}
      {error && (
        <div style={{
          background: 'var(--error-bg)',
          color: 'var(--error-text)',
          padding: '10px 15px',
          borderRadius: '8px',
          marginBottom: '15px',
          fontSize: '14px',
          textAlign: 'center'
        }}>
          ⚠️ {error}
        </div>
      )}

      {/* ملخص الهدايا */}
      <div style={{
        background: 'var(--bg-secondary)',
        borderRadius: '10px',
        padding: '15px',
        marginBottom: '20px',
        border: '1px solid var(--border-color)'
      }}>
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(120px, 1fr))',
          gap: '15px',
          textAlign: 'center'
        }}>
          <div>
            <div style={{
              color: 'var(--text-primary)',
              fontSize: '20px',
              fontWeight: 'bold',
              marginBottom: '5px'
            }}>
              {formatNumber(gifts.totalGifts)}
            </div>
            <div style={{
              color: 'var(--text-secondary)',
              fontSize: '12px'
            }}>
              إجمالي الهدايا
            </div>
          </div>
          
          <div>
            <div style={{
              color: 'var(--text-primary)',
              fontSize: '20px',
              fontWeight: 'bold',
              marginBottom: '5px'
            }}>
              {formatNumber(gifts.totalDiamonds)}
            </div>
            <div style={{
              color: 'var(--text-secondary)',
              fontSize: '12px'
            }}>
              إجمالي الماس
            </div>
          </div>
          
          <div>
            <div style={{
              color: 'var(--text-primary)',
              fontSize: '20px',
              fontWeight: 'bold',
              marginBottom: '5px'
            }}>
              {gifts.gifts.length}
            </div>
            <div style={{
              color: 'var(--text-secondary)',
              fontSize: '12px'
            }}>
              أنواع الهدايا
            </div>
          </div>
        </div>
      </div>

      {/* قائمة الهدايا */}
      <div style={{
        maxHeight: '400px',
        overflowY: 'auto',
        border: '1px solid var(--border-color)',
        borderRadius: '10px'
      }}>
        {gifts.gifts.length > 0 ? (
          gifts.gifts.map((gift, index) => (
            <div key={gift.id} style={{
              padding: '15px',
              borderBottom: index < gifts.gifts.length - 1 ? '1px solid var(--border-color)' : 'none',
              display: 'flex',
              alignItems: 'center',
              gap: '15px',
              background: index % 2 === 0 ? 'var(--bg-secondary)' : 'var(--bg-card)'
            }}>
              {/* صورة المرسل */}
              <div style={{
                width: '40px',
                height: '40px',
                borderRadius: '50%',
                background: 'var(--primary-color)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: 'white',
                fontSize: '16px',
                fontWeight: 'bold',
                flexShrink: 0
              }}>
                {gift.sender.charAt(0).toUpperCase()}
              </div>
              
              {/* تفاصيل الهدية */}
              <div style={{ flex: 1 }}>
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '10px',
                  marginBottom: '5px'
                }}>
                  <span style={{
                    color: 'var(--text-primary)',
                    fontWeight: 'bold',
                    fontSize: '14px'
                  }}>
                    {gift.name}
                  </span>
                  <span style={{
                    color: '#ff6b6b',
                    fontSize: '12px',
                    fontWeight: 'bold'
                  }}>
                    ×{gift.count}
                  </span>
                </div>
                
                <div style={{
                  color: 'var(--text-secondary)',
                  fontSize: '12px',
                  marginBottom: '3px'
                }}>
                  من: {gift.sender}
                </div>
                
                <div style={{
                  color: 'var(--text-secondary)',
                  fontSize: '11px'
                }}>
                  {formatTime(gift.timestamp)} • {gift.diamonds} 💎
                </div>
              </div>
              
              {/* قيمة الماس */}
              <div style={{
                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                color: 'white',
                padding: '8px 12px',
                borderRadius: '8px',
                fontSize: '12px',
                fontWeight: 'bold',
                textAlign: 'center',
                minWidth: '60px'
              }}>
                {gift.diamonds * gift.count} 💎
              </div>
            </div>
          ))
        ) : (
          <div style={{
            padding: '40px 20px',
            textAlign: 'center',
            color: 'var(--text-secondary)',
            fontSize: '14px'
          }}>
            {isLoading ? 'جاري تحميل الهدايا...' : 'لا توجد هدايا حتى الآن'}
          </div>
        )}
      </div>

      {/* آخر تحديث */}
      {gifts.lastUpdated && (
        <div style={{
          textAlign: 'center',
          fontSize: '12px',
          color: 'var(--text-secondary)',
          marginTop: '15px'
        }}>
          آخر تحديث: {new Date(gifts.lastUpdated).toLocaleString('ar-SA')}
        </div>
      )}
    </div>
  );
} 